<app-header></app-header>
<div class="title"></div>
<div class="container margin-top-70">
  <div class="col-md-6 mt-6">
    <table class="table table-bordered"></table>
  </div>
</div>

<div class="container table-responsive">
  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
    <button
      class="btn btn-primary btn-pkt"
      type="button"
      (click)="downloadReport()"
    >
      <i class="fa fa-download"></i> Download
    </button>
  </div>
</div>

<div>
  <div class="container" style="overflow-x: scroll;">
    <table
      class="table table-hover table-bordered table-striped mt-2 pkt-table-style"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col">Conversion Rate</th>
          <th scope="col">Currency Symbol</th>
          <th scope="col">Currency Name</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of products; let i = index;">
          <td>{{ product?.conversion_rate | number : '1.2-4' }}</td>
          <td>{{getCurrencySymb(product.iso4217)}}</td>
          <td>{{product.iso4217}}</td>
        </tr>
      </tbody>
    </table>
    Total Products {{totalProducts}}
  </div>
</div>

<footer
  class="text-center text-lg-start bg-dark text-light mt-4"
  style="bottom: 0px; position: fixed; width: 100%; z-index: 99;"
>
  <div class="text-center p-4" style="background-color: rgba(0, 0, 0, 0.05);">
    © 2024 Copyright:
    <a class="text-reset fw-bold" href="#">packt.com</a>
  </div>
</footer>
